import { MathUtils } from 'three';

export const lerp = MathUtils.lerp;
